import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';

import {DocumentDetails, NoCurrentVersion} from 'front-onceforall-core';

import * as utils from '../../utils';

function DossierDocumentList(props) {
  const displayNoCurrentVersion = documentVersions => {
    if (!documentVersions?.[0]?.type?.hasExample) {
      return <NoCurrentVersion/>;
    }
    return <NoCurrentVersion onExampleClick={event => utils.handleDocumentExampleOpen(event, documentVersions[0].type.name)}/>;
  };

  return (<>
    <h2 className="mt-5 mb-4">
      <Translate value={utils.getDossierName(props.dossier)}/>
    </h2>
    {props.documentsVersions.map(documentVersions => <DocumentDetails
      key={props.dossier + documentVersions[0].correlationId}
      documentVersions={documentVersions}
      documentPermissions={props.documentPermissions}
      documentActions={props.documentActions}
      correlationIdOpened={props.correlationIdOpened}
      handleClick={props.onClick}
      getTimelineVersionsFn={() => utils.getTimelineVersions(props.organisationId, documentVersions)}
      noCurrentVersion={displayNoCurrentVersion(documentVersions)}
    />)}
  </>);
}

DossierDocumentList.propTypes = {
  dossier: PropTypes.string.isRequired,
  documentsVersions: PropTypes.arrayOf(PropTypes.array),
  documentPermissions: PropTypes.object.isRequired,
  documentActions: PropTypes.object.isRequired,
  correlationIdOpened: PropTypes.string,
  organisationId: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired
};

export default DossierDocumentList;
